import { useResponsive } from '@ui/style/useResponsive';
import { spaceAboveHeader, headerHeight, spaceBelowHeader, bottomNavigation } from '@ui/style/variables';
const scrollbarThumbColor = 'rgba(0, 0, 0, 0.32)';
const useGridStyles = (maxHeight) => {
    const { isMobileIpadNavigation } = useResponsive();
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const containerEndPadding = 8;
    const gridMenu = 50;
    const columnHeading = 55.2;
    const headingHeightMobile = 50;
    const spaceBelowHeadingMobile = 8;
    const footer = 44;
    const cardContainerHeightDesktop = `${spaceAboveHeader + columnHeading + gridMenu + headerHeight + spaceBelowHeader + headingHeight + spaceBelowHeading + footer + pageEndPadding + containerEndPadding}px`;
    const cardContainerHeightMobile = `${headerHeight + headingHeightMobile + spaceBelowHeadingMobile + gridMenu + footer + bottomNavigation}px`;
    return {
        gridContainer: {
            // height: '100%',
            width: '100%',
            overflow: 'auto'
        },
        filterButton: {
            minWidth: 82
        },
        invitationsButton: {
            color: (theme) => theme.palette.primary.light
        },
        exportExcelButton: {
            color: (theme) => theme.palette.primary.light
        },
        userSelected: {
            color: (theme) => theme.palette.text.primary
        },
        bottomFilterDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        },
        bottomFilterDrawerButtons: {
            display: 'flex',
            flexDirection: 'row',
            gap: (theme) => theme.spacing(1)
        },
        gridRowContainer: {
            width: '100%',
            maxHeight: maxHeight ||
                (isMobileIpadNavigation ? `calc(100dvh - ${cardContainerHeightMobile})` : '100%'),
            height: maxHeight ||
                (isMobileIpadNavigation ? '100%' : `calc(100dvh - ${cardContainerHeightDesktop})`),
            '& .MuiDataGrid-virtualScroller': {
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': {
                    display: 'none',
                    width: 0,
                    height: 0
                }
            },
            '& .MuiDataGrid-scrollbar--horizontal': {
                opacity: 1,
                '&::-webkit-scrollbar': {
                    height: '6px'
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent'
                },
                '&::-webkit-scrollbar-thumb': {
                    background: `${scrollbarThumbColor} !important`,
                    borderRadius: '3px'
                },
                scrollbarWidth: 'thin',
                scrollbarColor: `${scrollbarThumbColor} transparent !important`
            },
            '& .MuiDataGrid-scrollbar--vertical': {
                '&::-webkit-scrollbar': {
                    width: '6px'
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent'
                },
                '&::-webkit-scrollbar-thumb': {
                    background: 'transparent',
                    borderRadius: '3px'
                },
                '&:hover::-webkit-scrollbar-thumb': {
                    background: `${scrollbarThumbColor} !important`
                },
                scrollbarWidth: 'thin',
                scrollbarColor: 'transparent transparent',
                '&:hover': {
                    scrollbarColor: `${scrollbarThumbColor} transparent`
                }
            },
            '&:has(.MuiAutocomplete-popper, .MuiMenu-root, .MuiPopover-root)': {
                '& .MuiDataGrid-scrollbar--horizontal, & .MuiDataGrid-scrollbar--vertical': {
                    '&::-webkit-scrollbar-thumb': {
                        background: 'transparent !important'
                    },
                    scrollbarColor: 'transparent transparent !important'
                }
            }
        }
    };
};
export default useGridStyles;
